import { render, staticRenderFns } from "./InputSubmit.vue?vue&type=template&id=1ff8d896&"
import script from "./InputSubmit.vue?vue&type=script&lang=js&"
export * from "./InputSubmit.vue?vue&type=script&lang=js&"
import style0 from "./InputSubmit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports